<!-- 找回密码 -->
<template>
  <div class="retrievePassword loginCom">
    <returnPage
      @retrievePassword="retrievePassword"
      type="retrievePassword"
    />
    <div class="retrievePsdMain loginMmain">
      <div class="retrievePsdMain_title">找回密码</div>
      <div class="PhoneNumIpt">
        <input
          type="tel"
          maxlength="11"
          placeholder="请输入手机号码"
          v-model="userTel"
          @keyup.delete="onDelete()"
        />
      </div>
      <div class="retrievePsdLine loginLine"></div>
    </div>
    <sendButton
      buttonText="发送验证码"
      @sendCodeBtn="forgetPsdBtn"
      :isActiveClass="isActiveClass"
      loginWay="forgetPassword"
    />

    <div
      class="sliderCode"
      v-show="sliderVer"
    >
      <div
        id="MyDom-id"
        class="nc-container"
      ></div>
    </div>
  </div>

</template>

<script>
import '@/assets/css/loginCommon.css';
import { Toast } from 'vant';
import returnPage from '@/components/login/returnPage.vue';
import sendButton from '@/components/login/sendButton.vue';
import { queryCode, reqPhonesliderCode } from '@/api/login';

export default {
  props: ['code'],
  components: { returnPage, sendButton },
  data() {
    return {
      userTel: '', // 手机号
      isActiveClass: false,
      sliderVer: false, // 是否显示滑块验证（显示/隐藏）
      tagNcFlag: false, // 滑块是否存在
    };
  },
  computed: {},
  watch: {
    userTel(val) {
      // const { userTel } = this;
      if (val?.length === 11) {
        this.isActiveClass = true;
        this.$store.dispatch('saveUserPhone', val);
        this.userTel = val;
        return;
      }
      this.isActiveClass = false;
    },
  },
  methods: {
    useNvc() {
      // eslint-disable-next-line no-underscore-dangle
      const _this = this;
      // 实例化nvc 对无痕验证进行初始化操作
      // eslint-disable-next-line no-undef
      AWSC.use('nvc', (state, module) => {
        // 初始化 调用module.init进行初始化
        window.nvc = module.init({

          // 应用类型标识。它和使用场景标识（scene字段）一起决定了无痕验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
          appkey: 'FFFF0N0000000000ACF9',
          // 使用场景标识。它和应用类型标识（appkey字段）一起决定了无痕验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的scene值，请务必正确填写。
          scene: 'nvc_message_h5',
          // test: module.TEST_BLOCK,
          // test: module.TEST_NC_PASS,
          // test: module.TEST_NC_BLOCK,
          // // 二次验证(滑块验证成功)获取人机信息串，跟随业务请求一起上传至业务服务器，由业务服务器进行验签。
          success(data) {
            // 滑块验证成功
            _this.getNewVerification(data);
          },
          // 前端二次验证失败时触发该回调参数
          fail(failCode) {
            Toast('验证失败，请刷新页面重新尝试');
          },
          // 前端二次验证加载异常时触发该回调参数。
          error(errorCode) {
            console.log(errorCode);
          },
        });
      });
    },
    async forgetPsdBtn() {
      const { userTel } = this;

      const isPhone = /^1[3-9]\d{9}$/g.test(userTel);
      if (userTel?.length !== 11 || !isPhone) {
        Toast('请输入正确格式的手机号');
        return;
      }
      if (this.sliderVer) return;

      const _this = this;
      window.nvc.getNVCValAsync((nvcVal) => {
        _this.getNewVerification(nvcVal);
      });

      // const result = await queryCode({
      //   type: 'forgetPassword',
      //   phone: userTel || '',
      // });

      // if (result.code !== 0) {
      //   Toast(result.msg);
      //   return;
      // }

      // this.isActiveClass = false;
      // const obj = Object.assign(this.pagesParams ? JSON.parse(this.pagesParams) : {}, {
      //   loginWay: 'forgetPassword',
      // });

      // this.$router.replace({
      //   name: 'getCode',
      //   params: obj,
      //   query: { redirect: this.$route.query.redirect },
      // });
    },
    // 发送验证码
    async getNewVerification(nvcVal) {
      const data = {
        company: 0,
        type: 'forgetPassword',
        phone: this.userTel,
        nvcVal,
      };
      const res = await reqPhonesliderCode(data);
      this.loading = false;
      if (res.code === 0) {
        if (res.data.status === 0) {
          this.isActiveClass = false;
          const obj = Object.assign(this.pagesParams ? JSON.parse(this.pagesParams) : {}, {
            loginWay: 'forgetPassword',
          });
          this.$router.replace({
            name: 'getCode',
            params: obj,
            query: { redirect: this.$route.query.redirect },
          });
        } else if (res.data.status === 1) {
          // 业务服务器请求回调控制是否需要二次验证
          if (res.data.bizCode === 800 || res.data.bizCode === 900) {
            // 无痕验证失败，直接拦截
            Toast('验证失败，请重新尝试');
          } else if (res.data.bizCode === 400) {
            this.sliderVer = true;
            if (!this.tagNcFlag) {
              // // 无痕验证失败，需要触发二次滑块验证
              const ncoption = {
                // 二次验证文案配置
                renderTo: '#MyDom-id',
                upLang: {
                  cn: {
                    // 加载状态提示。
                    LOADING: '加载中...',
                    // 等待滑动状态提示。
                    SLIDE: '请按住滑块，拖动到最右边',
                    // 验证通过状态提示。
                    SUCCESS: "<a style='margin-left:30px;-webkit-text-fill-color: #fff;'>验证通过</a>",
                    // 验证失败触发拦截状态提示。
                    ERROR: '滑动失败，请重新滑动,点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
                    // 验证失败触发拦截状态提示。
                    FAIL: '验证失败，请点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
                  },
                },
              };
              // 唤醒二次验证（滑动验证码）
              window.nvc.getNC(ncoption);
              this.tagNcFlag = true;
            }
          }
        }
      } else {
        Toast(res.msg);
        this.sliderVer = false;
        window.nvc.reset();
      }
    },

    onDelete() {
      const { userPhone } = this.$store.state;
      if (userPhone?.length === 0) return;
      this.$store.dispatch('saveUserPhone', '');
    },

    retrievePassword() {
      this.$router.replace({
        path: '/passwordLogin',
        query: JSON.parse(this.urlParams),
        params: JSON.parse(this.pagesParams),
      });
    },
    Toast(msg) {
      Toast({
        message: msg,
        duration: 3 * 1000,
        position: 'top',
      });
    },
  },
  created() {
    const { userPhone } = this.$store.state;
    this.userTel = userPhone || '';
    this.urlParams = window.localStorage.getItem('pagesQuery');
    this.pagesParams = window.localStorage.getItem('pagesParams');
    this.useNvc();
  },
  mounted() {
    document.getElementsByClassName('app')[0].setAttribute('style', 'background-color:#fff');
  },
  beforeDestroy() {
    document.getElementsByClassName('app')[0].removeAttribute('style');
  },
};
</script>
<style lang="scss" scoped>
.retrievePassword {
  .retrievePsdMain {
    .retrievePsdMain_title {
      padding: 89px 0 149px 0;
      color: #333;
      font-weight: 500;
      font-size: 51px;
    }

    .PhoneNumIpt {
      margin-bottom: 22px;
    }

    .retrievePsdLine {
      margin-bottom: 54px;
    }
  }
}
.sliderCode {
  margin-top: 45px;
}
::v-deep .nc_wrapper {
  margin: 0 auto;
}
::v-deep .nc-container .nc_scale .btn_ok,
::v-deep .nc-container .nc_scale span {
  height: 68px !important;
}
</style>
